<template>
  <div class="wrapper">
    <top-navbar></top-navbar>
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/locations" v-if="advertiserLength != 1">
        <img src="@/assets/static/img/menu/locations.svg" alt="..."/>
        <p>Locations</p>
      </sidebar-link>
      <sidebar-link to="/analytics">
        <img src="@/assets/static/img/menu/analytics.svg" alt="..."/>
        <p>Analytics</p>
      </sidebar-link>
      <sidebar-link to="/rewards">
        <img src="@/assets/static/img/menu/rewards.svg" alt="..."/>
        <p>Rewards</p>
      </sidebar-link>
      <sidebar-link to="/profile">
        <img src="@/assets/static/img/menu/profile.svg" alt="..."/>
        <p>Profile</p>
      </sidebar-link>
      <sidebar-link to="/support">
        <img src="@/assets/static/img/menu/support.svg" alt="..."/>
        <p>Support</p>
      </sidebar-link>
      <sidebar-link to="/billing" v-if="this.$store.getters.user.should_request_billing_info">
        <img src="@/assets/static/img/menu/support.svg" alt="..."/>
        <p>Billing</p>
      </sidebar-link>
    </side-bar>
    <div ref="mainPanel" class="main-panel">
      <first-sign-in-modal v-if="firstTime" v-on:hideFirstSignInModal="hideFirstSignInModal" />
      <dashboard-content @click="toggleSidebar" v-on:scrollTop="scrollTop"></dashboard-content>
    </div>
    <university-filter v-if="showUniversityFilter" />
    <modal />
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import Modal from '@/components/UIComponents/Modals/Modal.vue'
  import FirstSignInModal from '@/components/UIComponents/Modals/FirstSignInModal.vue'
  import UniversityFilter from '@/components/UIComponents/UniversityFilter.vue'

  export default {
    components: {
      TopNavbar,
      DashboardContent,
      MobileMenu,
      Modal,
      FirstSignInModal,
      UniversityFilter,
    },
    data: function () {
      return {
        current_route: '',
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      scrollTop (offset) {
        this.$nextTick(() => {
          this.$refs.mainPanel.scrollTop = offset;
        });
      },
      hideFirstSignInModal () {
        this.$store.dispatch('updateFirstTime', false);
      },
    },
    computed: {
      advertiserLength() {
        return this.$store.getters.advertisers.length;
      },
      firstTime() {
        return this.$store.getters.firstTime;
      },
      showUniversityFilter() {
        return ((this.current_route === '/locations') && this.$store.getters.user.is_staff);
      }
    },
    beforeRouteUpdate (to, from, next) {
      this.current_route = to.path;
      next();
    },
    mounted () {
      this.current_route = this.$router.currentRoute.path
    },
    destroyed () {
      if (this.$store.getters.firstTime) {
        this.$store.dispatch('updateFirstTime', false);
      }
    }
  }
</script>
